var _style, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlocksWave(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".spinner_zWVm{animation:spinner_5QiW 1.2s linear infinite,spinner_PnZo 1.2s linear infinite}.spinner_gfyD{animation:spinner_5QiW 1.2s linear infinite,spinner_4j7o 1.2s linear infinite;animation-delay:.1s}.spinner_T5JJ{animation:spinner_5QiW 1.2s linear infinite,spinner_fLK4 1.2s linear infinite;animation-delay:.1s}.spinner_E3Wz{animation:spinner_5QiW 1.2s linear infinite,spinner_tDji 1.2s linear infinite;animation-delay:.2s}.spinner_g2vs{animation:spinner_5QiW 1.2s linear infinite,spinner_CMiT 1.2s linear infinite;animation-delay:.2s}.spinner_ctYB{animation:spinner_5QiW 1.2s linear infinite,spinner_cHKR 1.2s linear infinite;animation-delay:.2s}.spinner_BDNj{animation:spinner_5QiW 1.2s linear infinite,spinner_Re6e 1.2s linear infinite;animation-delay:.3s}.spinner_rCw3{animation:spinner_5QiW 1.2s linear infinite,spinner_EJmJ 1.2s linear infinite;animation-delay:.3s}.spinner_Rszm{animation:spinner_5QiW 1.2s linear infinite,spinner_YJOP 1.2s linear infinite;animation-delay:.4s}@keyframes spinner_5QiW{0%,50%{width:7.33px;height:7.33px}25%{width:1.33px;height:1.33px}}@keyframes spinner_PnZo{0%,50%{x:1px;y:1px}25%{x:4px;y:4px}}@keyframes spinner_4j7o{0%,50%{x:8.33px;y:1px}25%{x:11.33px;y:4px}}@keyframes spinner_fLK4{0%,50%{x:1px;y:8.33px}25%{x:4px;y:11.33px}}@keyframes spinner_tDji{0%,50%{x:15.66px;y:1px}25%{x:18.66px;y:4px}}@keyframes spinner_CMiT{0%,50%{x:8.33px;y:8.33px}25%{x:11.33px;y:11.33px}}@keyframes spinner_cHKR{0%,50%{x:1px;y:15.66px}25%{x:4px;y:18.66px}}@keyframes spinner_Re6e{0%,50%{x:15.66px;y:8.33px}25%{x:18.66px;y:11.33px}}@keyframes spinner_EJmJ{0%,50%{x:8.33px;y:15.66px}25%{x:11.33px;y:18.66px}}@keyframes spinner_YJOP{0%,50%{x:15.66px;y:15.66px}25%{x:18.66px;y:18.66px}}")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "spinner_zWVm",
    x: 1,
    y: 1,
    width: 7.33,
    height: 7.33
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "spinner_gfyD",
    x: 8.33,
    y: 1,
    width: 7.33,
    height: 7.33
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "spinner_T5JJ",
    x: 1,
    y: 8.33,
    width: 7.33,
    height: 7.33
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "spinner_E3Wz",
    x: 15.66,
    y: 1,
    width: 7.33,
    height: 7.33
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "spinner_g2vs",
    x: 8.33,
    y: 8.33,
    width: 7.33,
    height: 7.33
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "spinner_ctYB",
    x: 1,
    y: 15.66,
    width: 7.33,
    height: 7.33
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "spinner_BDNj",
    x: 15.66,
    y: 8.33,
    width: 7.33,
    height: 7.33
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "spinner_rCw3",
    x: 8.33,
    y: 15.66,
    width: 7.33,
    height: 7.33
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "spinner_Rszm",
    x: 15.66,
    y: 15.66,
    width: 7.33,
    height: 7.33
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocksWave);
export default __webpack_public_path__ + "static/media/blocks-wave.3fa382407bec0ecba835e3b9a943e6a5.svg";
export { ForwardRef as ReactComponent };